import styled from "styled-components"

export const SocialLinks = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
`